import type {
  ConnectorParameterRestoreEntry,
  ConnectorParameterUndoEntry,
} from '../../types/parameterSetupUndo';

/** The part of a stored setup record that an undo can actually execute. */
export interface UndoPlanMaterial {
  entries: ConnectorParameterUndoEntry[];
  familyParameterRestoreEntries?: ConnectorParameterRestoreEntry[];
}

const restoreEntriesOf = (
  material: UndoPlanMaterial,
): ConnectorParameterRestoreEntry[] => material.familyParameterRestoreEntries ?? [];

/**
 * Families the undo will really open — one per distinct id across everything it
 * is going to send. Counting the families a run merely *considered* makes the
 * record claim work it cannot perform, which reads exactly like damage.
 */
export const countUndoPlanFamilies = (material: UndoPlanMaterial): number =>
  new Set([
    ...material.entries.map((entry) => entry.familyId),
    ...restoreEntriesOf(material).map((entry) => entry.familyId),
  ]).size;

/** Every parameter change the undo will send, restores included. */
export const countUndoPlanEntries = (material: UndoPlanMaterial): number =>
  material.entries.length + restoreEntriesOf(material).length;
